import * as Icon from "assets/svg";

export const notifications = [
  {
    isRead: false,
    title: "Isla Nublar SOC2 compliance report",
    createdAt: new Date("2023-10-01T09:42:00"),
    message: "Dennis Nedry commented on Isla Nublar SOC2 compliance report",
  },
  {
    isRead: true,
    title: "Jurassic Park Security Breach",
    createdAt: new Date("2023-10-02T14:30:00"),
    message: "John Hammond mentioned you in Jurassic Park Security Breach",
  },
  {
    isRead: false,
    title: "New Dinosaur Species Discovered",
    createdAt: new Date("2023-10-03T08:15:00"),
    message: "Dr. Alan Grant shared New Dinosaur Species Discovered",
  },
  {
    isRead: true,
    title: "Power Outage in Sector 12",
    createdAt: new Date("2023-10-04T11:00:00"),
    message: "Ray Arnold reported Power Outage in Sector 12",
  },
  {
    isRead: false,
    title: "Visitor Center Renovation",
    createdAt: new Date("2023-10-05T13:45:00"),
    message: "Ellie Sattler updated Visitor Center Renovation",
  },
  {
    isRead: true,
    title: "T-Rex Enclosure Maintenance",
    createdAt: new Date("2023-10-06T10:20:00"),
    message: "Robert Muldoon completed T-Rex Enclosure Maintenance",
  },
  {
    isRead: false,
    title: "Helicopter Arrival Schedule",
    createdAt: new Date("2023-10-07T09:00:00"),
    message: "Ian Malcolm shared Helicopter Arrival Schedule",
  },
  {
    isRead: true,
    title: "Park Visitor Feedback",
    createdAt: new Date("2023-10-08T16:30:00"),
    message: "Sarah Harding reviewed Park Visitor Feedback",
  },
  {
    isRead: false,
    title: "New Attraction Proposal",
    createdAt: new Date("2023-10-09T12:00:00"),
    message: "Tim Murphy proposed New Attraction Proposal",
  },
  {
    isRead: true,
    title: "Emergency Evacuation Drill",
    createdAt: new Date("2023-10-10T15:00:00"),
    message: "Lex Murphy announced Emergency Evacuation Drill",
  },
];

export const notificationTypes = {
  invoice: <img src={Icon.InvoicingIcon} alt="" className="size-full" />,
  property: <img src={Icon.PropertiesIcon} alt="" className="size-full" />,
  tenant: <img src={Icon.TenantIcon} alt="" className="size-full" />,
  prospect: <img src={Icon.ProspectIcon} alt="" className="size-full" />,
  task: <img src={Icon.TasksIcon} alt="" className="size-full" />,
  vendor: <img src={Icon.VendorIcon} alt="" className="size-full" />,
  report: <img src={Icon.ReportIcon} alt="" className="size-full" />,
  transaction: <img src={Icon.Transactions} alt="" className="size-full" />,
  lease: <img src={Icon.Lease} alt="" className="size-full" />,
  setting: <img src={Icon.SettingIcon} alt="" className="size-full" />,
  feedback: <img src={Icon.Feedbacks} alt="" className="size-full" />,
  user: <img src={Icon.Customers} alt="" className="size-full" />,
};
